import { render, staticRenderFns } from "./checkpointloteamostras.vue?vue&type=template&id=d87fc4d0&"
import script from "./checkpointloteamostras.vue?vue&type=script&lang=js&"
export * from "./checkpointloteamostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports